export const WITHDRAWAL_REASONS = [
  {name: 'Einsatz', label: 'Einsatz', default: true},
  {name: 'Verfall', label: 'Verfall', default: false},
  {name: 'Bruch', label: 'Bruch', default: false},
  {name: 'Fehlbestand', label: 'Fehlbestand', default: false},
  {name: 'Bestellung', label: 'Bestellung', default: false},
  {name: 'Bestandskorrektur', label: 'Bestandskorrektur', default: false},
  {name: 'Sonstiges', label: 'Sonstiges', default: false},
];

export function getDefaultWithdrawalReason() {
  for (let r of WITHDRAWAL_REASONS) {
    if (r.default === true) {
      return r.name;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/store-management/withdrawal-reasons.enum.ts